import {SET_SCOPE_ACTIVITY, SET_EMPLOYMENT, SET_EXPERIENCE, SET_COMPANY, SET_CITY} from '../constants/Filter'

const initialState = {
  scope_activity: {
    id: "",
    label: ""
  },
  employment: {
    id: "",
    label: ""
  },
  experience: {
    id: "",
    label: ""
  },
  company: {
    id: "",
    label: ""
  },
  city: {
    id: "",
    label: ""
  },
}

export default function filter(state = initialState, action) {
  switch (action.type) {
    case SET_SCOPE_ACTIVITY:
      return { ...state, scope_activity: {id: action.id, label: action.label} };
    case SET_EMPLOYMENT:
      return { ...state, employment: {id: action.id, label: action.label} };
    case SET_EXPERIENCE:
      return { ...state, experience: {id: action.id, label: action.label} };
    case SET_COMPANY:
      return { ...state, company: {id: action.id, label: action.label} };
    case SET_CITY:
      return { ...state, city: {id: action.id, label: action.label} };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/filter.js